import { useCallback } from "react"
import { SupportedTokenName } from "@mezo/sdk"

import {
  resetErrorState,
  selectActiveToken,
  setActiveToken,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import TokenSelect from "#/shared/components/TokenSelect"
import { PORTAL_TOKENS } from "#/shared/constants"

export default function DepositTokenSelect() {
  const activeToken = useDappSelector(selectActiveToken)
  const dispatch = useDappDispatch()

  const tokenSelectCallback = useCallback(
    (token: SupportedTokenName) => {
      dispatch(resetErrorState())
      dispatch(setActiveToken(token))
    },
    [dispatch],
  )

  return (
    <TokenSelect
      activeToken={activeToken}
      tokens={PORTAL_TOKENS}
      selectCallback={tokenSelectCallback}
    />
  )
}
